export const ClarityHelper = {
  // 1. 关联用户信息
  identify(user) {
    // 增加逻辑：确保 user 对象存在，避免 user.id 报错
    if (window.clarity && user && user.id) {
      window.clarity("identify", 
        user.id.toString(), 
        undefined, 
        undefined, 
        {
          name: user.name,
          account: user.account,
          orgCode: user.orgCode,
          lookLevel: user.look_level,
          // 额外建议：记录一下环境，方便在后台区分测试数据和正式数据
          env: process.env.NODE_ENV 
        }
      );
      // 生产环境建议关闭 console.log，或者增加判断
      if (process.env.NODE_ENV !== 'production') {
        console.log(`[Clarity] 已识别用户: ${user.name}`);
      }
    }
  },

  // 2. 追踪自定义行为
  trackEvent(eventName) {
    if (window.clarity) {
      window.clarity("event", eventName);
      // 增加一个调试日志，这样你在开发时点按钮，控制台能看到反馈
      if (process.env.NODE_ENV !== 'production') {
        console.log(`[Clarity] 触发事件: ${eventName}`);
      }
    }
  }
};